export const LOT_BIDDING_MODAL_GUIDE_ANCHORS = {
  bidAmount: 'bid-amount',
  createGroup: 'create-group',
  groupContainer: 'group-container',
  removeGroup: 'remove-group',
  calculator: 'minimal-jp-calculator',
  condition: 'condition',
  comment: 'comment',
  createTranslation: 'create-translation',
  createTranslationHint: 'create-translation-hint',
  notifyResult: 'notify-result',
  bidRules: 'bid-rules',
  greenCorner: 'green-corner',
} as const;
